<template>
  <div class="cms-article--rich">
    <component :is="getSliceComponent(slice)"
               v-for="(slice, index) in slices"
               :key="index"
               :slice="slice" />
  </div>
</template>

<script>
  import RendersArticle from '~/modules/cms/mixins/renders-article'
  import { warn } from '~/utils/errors'
  import SliceText from './slice-text'
  import SliceTextWithImage from './slice-text-with-image'
  import SliceThumbnailWithDescription from './slice-thumbnail-with-description'

  export default {
    name: 'Rich',
    mixins: [
      RendersArticle,
    ],
    components: {
      SliceText,
      SliceTextWithImage,
      SliceThumbnailWithDescription,
    },
    computed: {
      slices () {
        return this.$get(this.article, 'data.body', [])
      },
    },
    methods: {
      getSliceComponent (slice) {
        const type = this.$get(slice, 'slice_type')

        switch (type) {
          case 'text':
            return SliceText
          case 'text_with_image':
            return SliceTextWithImage
          case 'thumbnail_with_description':
            return SliceThumbnailWithDescription
          default:
            warn(`Unknown slice type: ${type}.`)
            return null
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
